import { css } from "@emotion/react";
import { theme } from "@product/scmp-sdk";

import { ImageStyle } from "~/components/content/content-schema-render/image/enums";

export const computeImageStyleRules = (imageStyle?: ImageStyle) => {
  if (!imageStyle || imageStyle === ImageStyle.Other) return;

  const styleMap = {
    [ImageStyle.Full]: css`
      inline-size: 100%;
    `,
    [ImageStyle.Fixed]: css`
      ${theme.breakpoints.up("tablet")} {
        max-inline-size: 451px;
        margin: auto;
      }
    `,
  };

  return styleMap[imageStyle];
};
